/* eslint-disable @typescript-eslint/camelcase */
import { Plugin } from '../../types';
import {loadConfig} from '../../config';

const config =  loadConfig()

const requests = []

async function pushRequest(request: any, response: any):Promise<void> {
  const scope = {} as any;
  scope.url = request.url();
  scope.headers = response.headers();
  scope.status = response.status();
  scope.method = response.request().method();
  try {
    scope.body = await response.text();
  } catch (err) {
    // nothing
  }

  requests.push({
    ...scope
  });
}

export const mocker: Plugin = {
  name: 'mocker',
  test:{
    collector: true,
    hook: {
      async beforeAll(page, context): Promise<void>{
        if(process.env.QALI_MOCK_API === 'true'){
          const path = require('path')
          const fs = require('fs')
          const currentTestPath = path.join(process.cwd(), config.rootDir)
          context._testPath = currentTestPath
          const snapshotPath = path.join(currentTestPath, `__network_cache__`, `${context._options.testName}.json`)
          if(process.env.QALI_MOCK_API_RESET === 'true'){
            fs.unlinkSync(snapshotPath)
          }
          if(!fs.existsSync(snapshotPath)){
            return await page.route('**/api/**', async (route, request) => {
              await route.continue()
              const response = await request.response()
              const redRequest = await response.request().redirectedTo()
              
              let redResponse
              if(redRequest){
                redResponse = await redRequest.response()
                await pushRequest(redRequest, redResponse)
              }
              await pushRequest(request, response);
              
            })
          }else{
            const savedrequests = JSON.parse(fs.readFileSync(snapshotPath).toString())
            const done = []
            const shiftRequests = (index) => {
              done.push(...savedrequests.splice(index, 1))
            }
            return await page.route('**/api/**', async (route, request) => {
              const reqIndex = savedrequests.findIndex(({url})=>url===request.url())
              let req = savedrequests[reqIndex]
              shiftRequests(reqIndex)
              if(!req){
                req = done.find(({url})=>url===request.url())
              }
              if(req.headers && req.headers.location ){
                const redirectLocation = new URL(req.headers.location, req.url).href
                const redirectResponseIndex = savedrequests.findIndex(({url})=>url===redirectLocation)
                if(redirectResponseIndex !== -1){
                  await route.fulfill(savedrequests[redirectResponseIndex])
                  shiftRequests(redirectResponseIndex)
                  return 
                }
              }
              if(!req){
                console.error('request', request.url(), 'not found')
              }
              await route.fulfill(req).catch(_=>{
                console.log('Error occured on mock api url ', request.url())
              })
            })
          }
        }
      },
      async afterAll(_, context): Promise<void>{
        
        if(process.env.QALI_MOCK_API === 'true'){
          const path = require('path')
          const cachePath = path.join(context._testPath, `__network_cache__`)
          const snapshotPath = path.join(cachePath, `${context._options.testName}.json`)
          const fs = require('fs')
          if(!fs.existsSync(cachePath)){
            fs.mkdirSync(cachePath)
          }
          if(!fs.existsSync(snapshotPath)){
            fs.writeFileSync(snapshotPath, JSON.stringify(requests,null,2))
          }
        }
      }
    }
  },
}
export default mocker

